import {atom} from 'jotai';
import {getAllRoleByUser} from '../Services/auth';
import {getRoleFunctionList} from '../Services/user';

// 用户权限认证
export const authStore = atom(async get => {
    const data = await getRoleFunctionList();
    // const roleList = get(roleListStore);

    return (key: string) => {
        // if (key === 'dynamic' && roleList[0].roleName === '超级管理员')
        //     return true;
        // if (key === 'roleSettings' && roleList[0].roleName === '超级管理员')
        return data.includes(key);
    };
});

// 角色列表
export const roleListStore = atom(async () => {
    return getAllRoleByUser();
});
